import CookieConsent from './CookieConsent';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import when from 'recompose/branch';
import withHandlers from 'recompose/withHandlers';
import renderNothing from 'recompose/renderNothing';
import lifecycle from 'recompose/lifecycle';

import { connect } from 'react-redux';
import { getCookieConsent } from '../../../store/selectors/cookies';
import { setCookieConsent } from '../../../store/thunks/cookies';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import cookieFactory from '../../../cookieFactory';

import withGlobalContent from '../../hocs/withGlobalContent';

import * as trackCookieConsent from '../../../analytics/category/cookieConsent';

const enhance = compose(
  connect((state, props) => ({
    allowCookies: getCookieConsent(state),
  }), dispatch => ({
    setAcceptedCookies: allowCookies => dispatch(setCookieConsent(allowCookies)),
  })),
  withState('hasMounted', 'setMounted', false),
  withHandlers({
    handleClose: props => e => {
      e.stopPropagation();
      e.preventDefault();

      const cookieConsentCookie = cookieFactory('allow_cookies');
      cookieConsentCookie.set(true);

      trackCookieConsent.close();

      props.setAcceptedCookies(true);
    }
  }),
  withGlobalContent,
  withProps(props => ({
    cookieConsent: get(props, 'globalContent.general.cookieConsent', { description: [], cta: '' })
  })),
  when(props => props.allowCookies || isEmpty(props.cookieConsent.description), renderNothing),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      props.setMounted(true);
      trackCookieConsent.show();
    }
  }),
);

export default enhance(CookieConsent);
